import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import "../Components/Upload/FileUpload.css";
import LoadingPage from "./LoadingPage.js";
import * as pdfjsLib from 'pdfjs-dist/build/pdf.mjs';
import 'pdfjs-dist/build/pdf.worker.mjs';

import { useSelector, useDispatch } from "react-redux";
import {
    TC_UNSAVED_ADD,
} from "../Constants/tcConstants.js";

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const FileUpload = () => {
  const dispatch = useDispatch();

  // const { tcid, tc, unsaveds } = useSelector((state) => state.tc);

  const navigate = useNavigate();
  const { user, isAuth } = useSelector((state) => state.user);


  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [contractType, setContractType] = useState(localStorage.getItem('contractType') || "");
  const [product, setProduct] = useState(localStorage.getItem('product') || "");
  const [company, setCompany] = useState(localStorage.getItem('company') || "");
  const [fileName, setFileName] = useState(localStorage.getItem('fileName') || "No file selected"); // Default text


  useEffect(() => {
    localStorage.setItem('contractType', contractType);
    localStorage.setItem('product', product);
    localStorage.setItem('company', company);
    if (selectedFile) {
      localStorage.setItem('fileName', selectedFile.name);
    } else {
      localStorage.setItem('fileName', "No file selected");
    }

    return () => {
      localStorage.removeItem('contractType');
      localStorage.removeItem('product');
      localStorage.removeItem('company');
      //localStorage.removeItem('fileName');
      //localStorage.removeItem('selectedFile'); 
      //setFileName("No file selected");
      //setSelectedFile(null);
    };
  }, [contractType, product, company, fileName, selectedFile]);

  useEffect(() => {
    if (isAuth && user && user.preferences) {
      const textSize = user.preferences.textSize;

      switch (textSize) {
        case 0: // Small
          document.documentElement.style.setProperty('--font-size-header', '1.5vw');
          document.documentElement.style.setProperty('--font-size-label', '14px');
          document.documentElement.style.setProperty('--font-size-input', '14px');
          document.documentElement.style.setProperty('--font-size-button', '0.8vw');
          document.documentElement.style.setProperty('--font-size-file-info', '14px');
          break;
        case 1: // Medium (default)
          document.documentElement.style.setProperty('--font-size-header', '2vw');
          document.documentElement.style.setProperty('--font-size-label', '16px');
          document.documentElement.style.setProperty('--font-size-input', '16px');
          document.documentElement.style.setProperty('--font-size-button', '1vw');
          document.documentElement.style.setProperty('--font-size-file-info', '16px');
          break;
        case 2: // Large
          document.documentElement.style.setProperty('--font-size-header', '3vw');
          document.documentElement.style.setProperty('--font-size-label', '24px');
          document.documentElement.style.setProperty('--font-size-input', '24px');
          document.documentElement.style.setProperty('--font-size-button', '2vw');
          document.documentElement.style.setProperty('--font-size-file-info', '24px');
          break;
        default:
          break;
      }
    } else if (!isAuth) { 
      document.documentElement.style.setProperty('--font-size-header', '2vw');
      document.documentElement.style.setProperty('--font-size-label', '16px');
      document.documentElement.style.setProperty('--font-size-input', '16px');
      document.documentElement.style.setProperty('--font-size-button', '1vw');
      document.documentElement.style.setProperty('--font-size-file-info', '16px');
    }
  }, [user, isAuth]);

  const handlePasteClick = () => {
    navigate('/pasteupload');
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    setFileName(file ? file.name : "No file selected"); // Save file name
  };

  const handleContractTypeChange = (e) => setContractType(e.target.value);
  const handleProductChange = (e) => setProduct(e.target.value);
  const handleCompanyChange = (e) => setCompany(e.target.value);

  const parsePDF = async (file) => {
    const fileReader = new FileReader();

    return new Promise((resolve, reject) => {
      fileReader.onload = async function () {
        const typedArray = new Uint8Array(this.result);
        const pdf = await pdfjsLib.getDocument({ data: typedArray }).promise;
        let text = "";

        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const textContent = await page.getTextContent();
          textContent.items.forEach((item) => {
            text += item.str + " ";
          });
        }
        resolve(text);
      };

      fileReader.onerror = () => {
        reject(new Error("Error reading the file"));
      };

      fileReader.readAsArrayBuffer(file);
    });
  };

  const handleAnalysisClick = async (event) => {
    event.preventDefault();

    if (!selectedFile) {
      alert("Please select a file to upload.");
      return;
    }

    if (!contractType) {
      alert("Please select a contract type.");
      return;
    }

    if (!product) {
      alert("Please enter the product T&C.");
      return;
    }

    if (!company) {
      alert("Please enter the company the product is under.");
      return;
    }

    try {

      setLoading(true);

      const parsedText = await parsePDF(selectedFile);

      // console.log("Parsed text:", parsedText.length, parsedText);

      const response = await fetch("/analyze", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          content: parsedText,
          contractType,
          product,
          company
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setLoading(false);
        // alert('File uploaded successfully from FileUpload.js!');
        // find the tcid and unsavedId from here: 
        // console.log('tcid:', data.tcid);
        // console.log('unsavedId:', data.unsavedId);

        dispatch({ type: TC_UNSAVED_ADD, payload: { tcid: data.tcid, token: data.unsavedId } });
        localStorage.clear();
        navigate(`/analysis/${data.tcid}`);
      } else {
        alert(`File upload failed: ${data.message}`);
        console.error(`File upload failed: ${data.message}`);
        setLoading(false);
      }
    } catch (error) {
      console.error('Error at the end of fileUpload.js:', error);
      alert('File upload failed...');
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingPage />;
  }


  return (
    <div className="container5">  
      <div className="header5">Analyze your contract</div>  

      <div className="container3">
        <div className="question-and-button">
          <p>What is your contract type?</p>
          <div className="dropdown">
            <select id="dropdownSelect" className="dropbutton" value={contractType} onChange={handleContractTypeChange}>
              <option value="">Select an option</option>
              <option value="Terms and Conditions">Terms and Conditions</option>
              <option value="Private Policy">Private Policy</option>
              <option value="Housing">Housing</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </div>
      </div>

      <div className="container3">
        <label htmlFor="input1" className="label1">What product is this T&C for?*</label>
        <input type="text" id="productInput" className="input1" name="input1" value={product} onChange={handleProductChange} />
      </div>

      <div className="container3">
        <label htmlFor="input1" className="label1">What company is the product under?*</label>
        <input type="text" id="companyInput" className="input1" name="input1" value={company} onChange={handleCompanyChange} />
      </div>
    
      <div className="container4">
        <div className="upload-header1">
        <h3>Upload Your Document</h3>
        </div>
        <div className="custom-file-upload">
          <button onClick={() => document.getElementById('fileInput').click()}>Browse...</button>
          <div className="file-info">
            <span className="file-label">Selected file:</span>
            <span id="fileName" className="file-name">{fileName || "No file selected"}</span>
          </div>
          <input type="file" id="fileInput" style={{ display: 'none' }} onChange={handleFileChange} />
        </div>
      </div>

      <div className="container6">
        <button className="button2" onClick={handlePasteClick}>
          I want to copy-paste my document instead...
        </button>
      </div>

      <div className="container2">
        <button className="upload-page-button" onClick={handleAnalysisClick}>
          Analyze Document
        </button>
      </div>
    </div>
  );
};

export default FileUpload;